(function() {
  // --- CONFIGURATION ---
  var redirectRules = {
    'AU': 'https://www.mecca.com/en-au/polite-society/',
    'KW': 'https://www.ulta.com.kw/en/shop-brands/polite-society',
  };
  var allowedCountries = ['US', 'JM']; 

  // --- LOGIC ---
  var currentUrl = window.location.href;
  
  // Safety check
  if (Object.values(redirectRules).some(function(target) { return currentUrl.includes(target); })) {
    return;
  }

  fetch('https://get.geojs.io/v1/ip/country.json')
    .then(function(response) { return response.json(); })
    .then(function(data) {
      var country = data.country;
      console.log("Visitor Country detected:", country);

      // RULE 1: Redirects
      if (redirectRules[country]) {
        window.location.replace(redirectRules[country]);
        return;
      }

      // RULE 2: Allowed
      if (allowedCountries.includes(country)) {
        return; 
      }

      // RULE 3: Block (View Only)
      console.log('Restricting access... disabling buttons and hiding prices.');
      
      // Run immediately
      restrictAccess();
      
      // Retry loop (catch lazy loading/Rebuy)
      var attempts = 0;
      var intervalId = setInterval(function() {
        restrictAccess();
        attempts++;
        if (attempts > 10) clearInterval(intervalId); 
      }, 500);

      // Watch for page changes
      monitorPageChanges();
    })
    .catch(function(err) {
      console.log('GeoIP lookup failed', err);
    });

  // --- MAIN RESTRICTION FUNCTION ---
  function restrictAccess() {
    // 1. Hide Dynamic Checkout Buttons
    var dynamicButtons = document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons');
    dynamicButtons.forEach(function(btn) { btn.style.display = 'none'; });

    // 2. Hide Rebuy / Upsell Widgets
    var rebuyContainers = document.querySelectorAll('.rebuy-widget-container, .product-upsells-container, [id^="rebuy-widget"]');
    rebuyContainers.forEach(function(widget) {
       widget.style.display = 'none';
    });

    // 3. Hide PRICING
    // We target the specific classes found in your screenshots:
    // .price-inline-wrapper -> Handles PLP and Suggested Modules
    // [id^="price-template--"] -> Handles the main PDP price block
    // .price -> Generic fallback
    var priceElements = document.querySelectorAll('.price, .price-inline-wrapper, [id^="price-template--"]');
    priceElements.forEach(function(el) {
        el.style.display = 'none';
    });

    // 4. Disable Main "Add to Cart" Form Button
    var forms = document.querySelectorAll('form.shopify-product-form');
    forms.forEach(function(form) {
      var btn = form.querySelector('.product-form__submit');
      if (btn && !btn.disabled) {
        btn.disabled = true; 
        btn.style.opacity = '0.5'; 
        btn.style.cursor = 'not-allowed'; 
        btn.innerText = 'Not Available in Your Region';
      }
    });
  }

  // --- HELPER: MONITOR DOM CHANGES ---
  function monitorPageChanges() {
    var targetNode = document.body;
    var config = { childList: true, subtree: true };

    var callback = function(mutationsList, observer) {
      restrictAccess();
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
})();